/**
 * Created by Victor Rojo on 6/11/19.
 */
export class TankDeliveryNote{
  constructor(
    public iPlaceId: string,
    public deliveryNoteId: string,
    public startDate: Date,
    public endDate: Date,
    public creationDate: number,
    public creationUser: number,
    public hdSiraExported: boolean,
    public lines: TankDeliveryNoteLine[]
  ){}
}
export class TankDeliveryNoteLine{
  constructor(
    public tankId: string,
    public localTankId: number,
    public tankName: string,
    public productName: string,
    public productId: string,
    public volume: number,
    public temperature: number,
    public price: number
  ){}
}
